<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-06-30 17:25:26
 * @FilePath: \mrc-ess-fronted\src\Layout\components\breadcrumbs.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-03-09 13:14:08
-->
<template>
  <v-breadcrumbs
    v-if="!hidden"
    style="height: 18px"
    class="flex-shrink-1 pa-0"
    :items="BreadcrumbList"
    divider=">"
  >
    <template v-slot:item="{ item }">
      <v-breadcrumbs-item
        :disabled="item.disabled"
        :to="item.disabled ? null : item.to"
        :active-class="item.disabled ? 'text--secondary ' : 'primary--text'"
      >
        <span
          class="text-caption"
          :style="{
            cursor: item.disabled ? 'default ' : 'pointer ',
          }"
          >{{ $t(item.text) }}</span
        ></v-breadcrumbs-item
      >
      <!-- @click="$toPage(item.to,null,'replace')" -->
    </template>
    <template v-slot:divider>
      <span class="text-caption">{{ ">" }}</span>
    </template>
  </v-breadcrumbs>
</template>
<script>
import routers from "@/router/routers";
import router_addmin from "@/router/router_admin";
export default {
  name: "Breadcrumb",
  props: {
    hidden: { default: false, type: Boolean },
  },
  created() {
    this.BreadcrumbList = this.getBreadcrumb();
  },
  watch: {
    $route() {
      this.BreadcrumbList = this.getBreadcrumb();
    },
  },
  data() {
    return {
      BreadcrumbList: [],
    };
  },
  methods: {
    getBreadcrumb() {
      let router = this.$route;
      let args = window.location.href.substring(
        window.location.href.lastIndexOf("/") + 1,
        window.location.href.length
      );
      if (router["meta"]) {
        if (!router["meta"]["bred"]) return [];
        let routerArr = router["meta"]["bred"].split("/");
        let routerBred = router["meta"]["bred"];
        routerArr.shift(); //去除第一个空字符
        let tempArr = [];
        routerArr.forEach((item, index) => {
          if (item.indexOf(":") == -1) {
            let str = routerBred.substring(0, routerBred.indexOf(item) - 1);
            tempArr.push(str);
          }
          // let str = routerBred.substring(0, routerBred.indexOf(item) - 1);
          // tempArr.push(str);
        });
        tempArr.shift();
        tempArr.push(routerBred);
        //
        let arr = [];

        tempArr.forEach((item, index) => {
          if (tempArr.indexOf("/admin") != -1) {
            if (item == "/admin") {
              arr.push({
                to: "/",
                text: "label_essweb_dashboard_list_title",
                disabled: false,
              });
            } else {
              let cur = router_addmin.find(
                (ele) => ele["meta"]["router"] === item
              );
              if (cur) {
                arr.push({
                  to: cur.meta.router
                    .replace(":args", args)
                    .replace(":params", args),
                  text: cur.meta.text,
                  disabled: index == tempArr.length - 1 ? true : false,
                });
              }
            }
          } else {
            let cur = routers.find((ele) => {
              if (ele["meta"]) return ele["meta"]["router"] === item;
            });
            if (cur) {
              arr.push({
                to: cur.meta.router
                  .replace(":args", args)
                  .replace(":params", args),
                text: cur.meta.text,
                disabled: index == tempArr.length - 1 ? true : false,
              });
            }
          }
        });
        return arr;
      } else {
        return [];
      }

      //2
      // console.log(router);
      // let matched = this.$route.matched;
      // let arr = [];
      // matched.forEach((item, index) => {
      //   arr.push({
      //     to: item.path,
      //     text: item.name,
      //     disabled: index == matched.length - 1 ? true : false,
      //   });
      // });
      // console.log(arr);
      // return arr;
    },
  },
};
</script>
